/**
 * Route for `custom-tracking-domain-via-cname`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomTrackingDomainViaCnamePage } from "../features/custom-tracking-domain-via-cname/CustomTrackingDomainViaCnamePage";

export const customTrackingDomainViaCnameRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-tracking-domain-via-cname",
	component: CustomTrackingDomainViaCnamePage,
});

export default customTrackingDomainViaCnameRoute;
